import script from "./BioIntelligentPart4.vue?vue&type=script&setup=true&lang=js"
export * from "./BioIntelligentPart4.vue?vue&type=script&setup=true&lang=js"

import "./BioIntelligentPart4.vue?vue&type=style&index=0&id=5eaac89e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eaac89e"]])

export default __exports__